import { cloneDeep } from '_utils';
import PuzzleService from '_services/rest/modules/puzzle';
import { MODEL } from './components/PuzzleModel';

export default {
  state: {
    types: [],
    levels: [],
    status: [],
    puzzleList: null,
    puzzleEdit: null,
  },

  mutations: {
    setPuzzleList(state, response) {
      state.puzzleList = response;
    },
    setTypesList(state, response) {
      state.types = response;
    },
    setLevelsList(state, response) {
      state.levels = response;
    },
    setStatusList(state, response) {
      state.status = response;
    },
    setPuzzle(state, response) {
      state.puzzleEdit = Object.assign(cloneDeep(MODEL), response);
    },
  },

  actions: {
    getPuzzleList({ commit }, params) {
      return PuzzleService.getList(params)
        .then(response => {
          commit('setPuzzleList', response);
        });
    },
    getTypesList({ commit }) {
      return PuzzleService.getTypesList()
        .then(response => {
          commit('setTypesList', response);
        });
    },
    getLevelsList({ commit }) {
      return PuzzleService.getLevelsList()
        .then(response => {
          commit('setLevelsList', response);
        });
    },
    getStatusList({ commit }) {
      return PuzzleService.getStatusList()
        .then(response => {
          commit('setStatusList', response);
        });
    },
    getPuzzle({ commit }, params) {
      return PuzzleService.getPuzzleById(params)
        .then(response => {
          commit('setPuzzle', response);
          return response;
        });
    },
  },
};
